import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgOperationsController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgOperationsController.php:17
* @route 'https://org.proexpert.app/org/operations'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/operations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgOperationsController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgOperationsController.php:17
* @route 'https://org.proexpert.app/org/operations'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgOperationsController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgOperationsController.php:17
* @route 'https://org.proexpert.app/org/operations'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgOperationsController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgOperationsController.php:17
* @route 'https://org.proexpert.app/org/operations'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgOperationsController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgOperationsController.php:17
* @route 'https://org.proexpert.app/org/operations'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgOperationsController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgOperationsController.php:17
* @route 'https://org.proexpert.app/org/operations'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgOperationsController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgOperationsController.php:17
* @route 'https://org.proexpert.app/org/operations'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const operations = {
    index: Object.assign(index, index),
}

export default operations